import { rei } from "@/services/api"

class InteiroTeorService {
  static getList (params) {
    return rei.get(`inteiro-teor`, {params}).then(res => res.data)
  }

  static cadastrarInteiroTeor (inteiroTeor) {
    return rei.post(`inteiro-teor`, inteiroTeor).then(res => res.data)
  }

  static atualizarInteiroTeor (inteiroTeor, id) {
    return rei.put(`inteiro-teor/${id}`, inteiroTeor).then(res => res.data)
  }

  static excluirInteiroTeor (id) {
    return rei.delete(`inteiro-teor/${id}`)
  }
}

export default InteiroTeorService